export const makeLoadFailed = () => Promise.reject(Error('Cache load failed'));